// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'
import { rtlFlipCss } from '../iconStyles'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path
      d="M21 2H3c-.54.04-.96.46-1 1v18c.04.54.46.96 1 1h18c.54-.04.96-.46 1-1V3a1.08 1.08 0 0 0-1-1Zm-1 18H4v-3h16v3Zm0-5h-3v-2h-2v2H4V4h11v2h2V4h3v11Zm-3-7h-2v3h2V8Z"
      className={rtlFlipCss}
    />
  </BaseIcon>
)
